import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

interface SectionHeadingProps {
  id?: string;
  children: ReactNode;
  className?: string;
}

/**
 * Título das seções da Home ("Reconheça seus colegas", "Realizações destaque do prefixo").
 * Declara o próprio `leading-*`: o `rsuite.min.css` impõe `line-height: 50px` a todo h2.
 */
export function SectionHeading({ id, children, className = '' }: SectionHeadingProps) {
  return (
    <h2 id={id} className={`font-display text-jj-title font-bold leading-tight text-brand-blue-dark ${className}`}>
      {children}
    </h2>
  );
}

interface ArrowLinkProps {
  to: string;
  children: ReactNode;
}

/**
 * Atalho em caixa-alta com seta que avança no hover ("Ver todos do prefixo →"). Em `brand-blue-dark`,
 * não no `brand-blue` do design: sobre o rosa e o creme dos painéis o azul claro reprova no contraste AA.
 * D3: 7px e 3px não têm degrau no Tailwind.
 */
export function ArrowLink({ to, children }: ArrowLinkProps) {
  return (
    <Link
      to={to}
      className="group flex items-center gap-[7px] whitespace-nowrap font-text text-jj-label font-bold uppercase tracking-[.04em] text-brand-blue-dark hover:text-brand-blue-dark hover:underline"
    >
      {children}
      <FiArrowRight
        aria-hidden="true"
        size={14}
        className="transition-transform duration-jj-base ease-jj-standard group-hover:translate-x-[3px] motion-reduce:transition-none"
      />
    </Link>
  );
}
